'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResellerList = _react2.default.createClass({
  displayName: 'ResellerList',

  propTypes: {
    data: _react.PropTypes.object.isRequired
  },
  render: function render() {
    var _this = this;

    var columns = [{
      title: '编号',
      key: 'id',
      dataIndex: 'reseller_id'
    }, {
      title: '名称',
      key: 'name',
      dataIndex: 'name'
    }, {
      title: '手机号',
      key: 'mobile',
      dataIndex: 'mobile'
    }, {
      title: '省',
      key: 'state',
      dataIndex: 'shop_state'
    }, {
      title: '市',
      key: 'city',
      dataIndex: 'shop_city'
    }, {
      title: '区',
      key: 'district',
      dataIndex: 'shop_district'
    }, {
      title: '地址',
      key: 'address',
      dataIndex: 'shop_address'
    }, {
      title: '状态',
      key: 'status_info',
      dataIndex: 'status_info'
    }];
    var data = this.props.data;
    var items = data.items,
        error = data.error,
        pagination = data.pagination;

    var pager = Object.assign(_constants.PaginationConfig, {
      total: pagination.total,
      current: pagination.current_page,
      pageSize: pagination.per_page,
      onChange: function onChange(page, pageSize) {
        // 页码改变的回调，参数是改变后的页码及每页条数
        _this.props.onChange(page);
      }
    });
    var tableConfig = {
      columns: columns,
      locale: { emptyText: error && !error.ok ? '\u7F51\u7EDC\u9519\u8BEF\uFF1A' + error.statusText : '暂无数据' },
      dataSource: items,
      rowKey: function rowKey(record) {
        return record.reseller_id;
      },
      pagination: pager
    };
    return _react2.default.createElement(_table2.default, tableConfig);
  }
});

exports.default = ResellerList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/reseller_list.js
// module id = 1574
// module chunks = 0